import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { AiOutlinePieChart, AiOutlinePoweroff } from "react-icons/ai";
import { RiSuitcaseLine } from "react-icons/ri";
import { BiCheckSquare } from "react-icons/bi";
import { BsBuilding } from "react-icons/bs";
import { MdOutlineNotificationsNone } from "react-icons/md";
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
import { IMAGE_BASE_URL } from "../../common/Constants";
import { useDispatch, useSelector } from "react-redux";
import { NotificationContext } from ".";
import axios from "../../axios/axios";
import usePrevLocation from "../../common/hooks";
import { resetLoanAppFilter } from "../../redux/slice/dealerCommFilterSlice";
import { resetDealerNotification } from "../../redux/slice/adminNotificationSlice";
import { resetFloorAppForm } from "../../redux/slice/newFloorApplication";
import Noimage from "../../images/noimage.png";

const SideBar = (props) => {
  const accessToken = localStorage.getItem("dealerModuleToken");
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const prevLocation = usePrevLocation(location);
  const { authData, notificationCount, setNotificationCount, setAuthData, flooringCount, setFlooringCount } = useContext(
    AuthenticationContext
  );
  const [expanded, setExpanded] = useState(false);
  const [mobSideBar, setMobSideBar] = useState(false);
  const [railNav, setRailNav] = useState(
    window.innerWidth < 991 ? false : true
  );

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const GetDealerInfo = async () => {
    try {
      const resp = await axios.get("/profile/info");
      if (resp.status < 400) {
        setAuthData(resp?.data?.data);
      }
    } catch (error) {
    }
  };


  const GetAdminNotifications = async () => {
    const { data } = await axios.post(
      `/notification/list`,
      {
        productType: "",
        sortBy: "week",
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    const temp = data?.data;
    if (temp?.length > 0) {
      let unReadNotification = temp?.filter((it) => it?.status === 0)?.length;
      setNotificationCount(unReadNotification);
    } else {
      setNotificationCount(0);
    }
  };

  const GetFlooringNotification = async () => {
    try {
      const { data } = await axios.get(
        `/flooring/notifications?search_key=${""
        }
      &sortOrder=31
      &vehicle_type=${""}`,
        {
          search_key: "",
          productType: "",
          sortBy: "31",
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      const temp = data?.data?.notification;
      const Array = Object.values(temp).flat();
      const unreadFlooringNotification = Array?.filter((it) => it?.read_at === null || it?.readt_at === "")
      setFlooringCount(unreadFlooringNotification?.length);
    }
    catch (err) {

    }
  };

  const handleSideBar = () => {
    setRailNav(!railNav);
    props.SideBar(!railNav);
  };
  const Logout = () => {
    // localStorage.clear();
    localStorage.removeItem("dealerModuleToken");
    navigate("/login");
  };

  useEffect(() => {
    if (!railNav) {
      if (location.pathname !== "/notifications/loan/changes" || location.pathname !== "notification/flooring_updates") {
        GetAdminNotifications();
        GetFlooringNotification();
      }
    }
  }, [expanded, railNav]);

  useEffect(() => {
    if (prevLocation.pathname !== location.pathname) {
      if (
        prevLocation.pathname?.includes(location.pathname) ||
        location.pathname.includes(prevLocation.pathname) ||
        location.pathname === "/case-list" ||
        location.pathname === "/case-detail"
      ) {
        return;
      } else {
        dispatch(resetLoanAppFilter());
        dispatch(resetDealerNotification());
        dispatch(resetFloorAppForm());
      }
    }
  }, [prevLocation, location]);

  useEffect(() => {
    GetAdminNotifications();
    GetDealerInfo();
    GetFlooringNotification();
  }, []);

  const GetSideBarLink = (value, item) => {
    switch (value) {
      case "new-loan-application":
        return (
          <NavLink
            to="/loan-application"
            state={{ ...item }}
            className="dash_sub_menu"
          >
            {item?.label}
          </NavLink>
        );
      case "dealer-commision":
        return (
          <NavLink
            to="/loan-products"
            state={{ ...item }}
            className="dash_sub_menu"
          >
            {item?.label}
          </NavLink>
        );
      case "loan-application-cases":
        return (
          <NavLink
            to="/case-list"
            state={{ ...item }}
            className="dash_sub_menu"
          >
            {item?.label}
          </NavLink>
        );
      case "user-roles":
        return (
          <NavLink
            to="/user-roles"
            state={{ ...item }}
            className="dash_sub_menu"
          >
            User Roles
          </NavLink>
        );
      case "user-accounts":
        return (
          <NavLink
            to="/user-accounts"
            state={{ ...item }}
            className="dash_sub_menu"
          >
            User Accounts
          </NavLink>
        );
      case "flooring-application":
        return (
          <NavLink
            to="/new-flooring-application"
            state={{ ...item, appId: null }}
            className="dash_sub_menu"
          >
            New Floorig Application
          </NavLink>
        );
      case "flooring-rates":
        return (
          <NavLink
            to="/flooring-rates"
            state={{ ...item }}
            className="dash_sub_menu"
          >
            Flooring Rates
          </NavLink>
        );
      case "flooring-vouchers":
        return (
          <NavLink
            to="/flooring-voucher"
            state={{ ...item }}
            className="dash_sub_menu"
          >
            Flooring Vouchers
          </NavLink>
        );
      case "flooring-cases":
        return (
          <NavLink
            to="/flooring-cases"
            state={{ ...item }}
            className="dash_sub_menu"
          >
            Flooring Cases
          </NavLink>
        );
      case "application-updates":
        return (
          <div className="flex items-center justify-center">
            <NavLink
              to="/notification/application_updates"
              state={{ ...item }}
              className="dash_sub_menu flex items-center justify-between"
              style={{ display: "flex" }}
            >
              Application Updates
              <span
                className="inline-block h-[22px] w-[22px] flex-shrink-0 bg-[#FD4954] flex items-center justify-center rounded-[50%] text-white text-[10px] font-[600] mr-[10px]"
                style={{ display: railNav && "none" }}
              >
                <span className="relative left-[-0.5px]">
                  {notificationCount}
                </span>
              </span>
            </NavLink>
          </div>
        );
      case "flooring-updates":
        return (
          <NavLink
            to="/notification/flooring_updates"
            state={{ ...item }}
            className="dash_sub_menu flex items-center justify-between"
            style={{ display: "flex" }}
          >
            Flooring Updates
            <span
              className="inline-block h-[22px] w-[22px] flex-shrink-0 bg-[#FD4954] flex items-center justify-center rounded-[50%] text-white text-[10px] font-[600] mr-[10px]"
              style={{ display: railNav && "none" }}
            >
              <span className="relative left-[-0.5px]">
                {flooringCount}
              </span>
            </span>
          </NavLink>
        );
      default:
        return null;
    }
  };



  return (
    <>
      <div
        className={`items-center border-b border-slate-300 justify-between p-[20px_32px] bg-white hidden max-[991px]:flex w-[100%] z-[99]`}
      >
        <img src="/images/site_logo.png" alt="logo" />
        <span
          className="inline-block relative top-[2px] cursor-pointer"
          onClick={() => setMobSideBar(!mobSideBar)}
        >
          <img src="/images/menu_bar.svg" alt="menu bar" />
        </span>
      </div>
      <div
        className={`backDrop ${!mobSideBar && "hidden"}`}
        onClick={() => setMobSideBar(!mobSideBar)}
      ></div>
      <div
        onClick={(e) => {
          e.stopPropagation();
          setRailNav(false);
          props.SideBar(false);
        }}
        onMouseLeave={() => {
          setRailNav(true);
          props.SideBar(true);
        }}
        className={`sidebar_box flex-shrink-0 sticky top-[-1px] z-[99] ${railNav && "w-[50px!important]"
          } ${mobSideBar && "active"}`}
      >
        <div className="relative h-[100%] flex flex-col">
          <div
            className={`flex items-center justify-between mt-[17px] mb-[50px] ${railNav ? "px-[13px]" : "px-[19px]"
              }`}
          >
            <img
              src="/images/site_logo.png"
              alt="logo"
              style={{ display: railNav && "none" }}
            />
            <span
              className="inline-block relative top-[4px] cursor-pointer"
              onClick={handleSideBar}
            >
              <img
                src="/images/site_logo.png"
                alt="logo"
                style={{
                  display: !railNav && "none",
                  height: "100%",
                  width: "100%",
                }}
              />
            </span>
          </div>
          <Link to="/" className="flex items-center dashboard_menu">
            <AiOutlinePieChart
              className={`text-[#0560FB] text-[20px] ${!railNav && "mr-[12px]"
                }`}
            />
            <span className={`${railNav && "hidden"}`}>Dashboard</span>
          </Link>
          {authData?.permissions
            ?.filter((it) => it?.name === "loan")
            ?.map((it) => it?.submodules?.map((item) => item.permission))
            .flat()
            ?.includes(1) && (
              <Accordion
                expanded={expanded === "panel1"}
                onChange={handleChange("panel1")}
                onClick={() => setRailNav(false)}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMore
                      htmlColor={expanded !== "panel1" ? "#0F172A" : "white"}
                      style={{ display: railNav && "none" }}
                    />
                  }
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  aria-expanded="false"
                >
                  <div className="flex items-center text-[14px] text-[#0F172A] accorMenu">
                    <RiSuitcaseLine
                      className={`text-[#0560FB] text-[20px] ${!railNav && "mr-[12px]"
                        }`}
                    />
                    <span className={`${railNav && "hidden"}`}>Loans</span>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  className={`relative sub_menu_box before:h-[94%!important] ${railNav && "hidden"
                    }`}
                >
                  {authData?.permissions
                    ?.filter((it) => it?.name === "loan")
                    ?.map((it) =>
                      it?.submodules?.map(
                        (item) =>
                          item.permission == 1 && GetSideBarLink(item?.name, item)
                      )
                    )}
                  <NavLink to="/dealer-commision-report" className="dash_sub_menu">
                    Dealer Commision Report
                  </NavLink>
                </AccordionDetails>
              </Accordion>
            )}

          {authData?.permissions
            ?.filter((it) => it?.name === "flooring")
            ?.map((it) => it?.submodules?.map((item) => item.permission))
            .flat()
            ?.includes(1) && (
              <Accordion
                expanded={expanded === "panel2"}
                onChange={handleChange("panel2")}
                onClick={() => setRailNav(false)}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMore
                      htmlColor="#0F172A"
                      style={{ display: railNav && "none" }}
                    />
                  }
                  aria-controls="panel2a-content"
                  id="panel2a-header"
                >
                  <div className="flex items-center text-[14px] text-[#0F172A] accorMenu">
                    <BiCheckSquare
                      className={`text-[#0560FB] text-[20px] ${!railNav && "mr-[12px]"
                        }`}
                    />
                    <span className={`${railNav && "hidden"}`}>Flooring</span>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  className={`sub_menu_box before:h-[93%!important] relative ${railNav && "hidden"
                    }`}
                >
                  {authData?.permissions
                    ?.filter((it) => it?.name === "flooring")
                    ?.map((it) =>
                      it?.submodules?.map(
                        (item) =>
                          item.permission == 1 && GetSideBarLink(item?.name, item)
                      )
                    )}

                </AccordionDetails>
              </Accordion>
            )}
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
            onClick={() => setRailNav(false)}
          >
            <AccordionSummary
              expandIcon={
                <ExpandMore
                  htmlColor="#0F172A"
                  style={{ display: railNav && "none" }}
                />
              }
              aria-controls="panel3a-content"
              id="panel3a-header"
            >
              <div className="flex items-center text-[14px] text-[#0F172A] accorMenu">
                <BsBuilding
                  className={`text-[#0560FB] text-[18px] ${!railNav && "mr-[12px]"
                    } ${railNav && "relative left-[1.5px]"}`}
                />
                <span className={`${railNav && "hidden"}`}>Accounts</span>
              </div>
            </AccordionSummary>
            <AccordionDetails
              className={`sub_menu_box relative ${railNav && "hidden"}`}
            >
              {authData?.permissions
                ?.filter((it) => it?.name === "accounts")
                ?.map((it) =>
                  it?.submodules?.map(
                    (item) =>
                      item.permission == 1 && GetSideBarLink(item?.name, item)
                  )
                )}
              <NavLink to="/accounts/profile" className="dash_sub_menu">
                Profile
              </NavLink>
            </AccordionDetails>
          </Accordion>
          {authData?.permissions
            ?.filter((it) => it?.name === "notification")
            ?.map((it) => it?.submodules?.map((item) => item.permission))
            .flat()
            ?.includes(1) && (
              <Accordion
                expanded={expanded === "panel4"}
                onChange={handleChange("panel4")}
                onClick={() => setRailNav(false)}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMore
                      htmlColor="#0F172A"
                      style={{ display: railNav && "none" }}
                    />
                  }
                  aria-controls="panel4a-content"
                  id="panel4a-header"
                >
                  <div className="flex items-center text-[14px] text-[#0F172A] accorMenu relative">
                    <MdOutlineNotificationsNone
                      className={`text-[#0560FB] text-[20px] ${!railNav && "mr-[12px]"
                        } `}
                    />
                    {railNav && (notificationCount > 0 || flooringCount > 0) && (
                      <span className="bg-[#FD4954] h-[8px] w-[8px] rounded-[50%] absolute top-[0] right-[0]"></span>
                    )}
                    <span className={`${railNav && "hidden"}`}>Notification</span>
                  </div>
                  {notificationCount !== 0 && notificationCount !== undefined && (
                    <span
                      className="inline-block h-[22px] w-[22px] bg-[#FD4954] flex items-center justify-center rounded-[50%] text-white text-[10px] font-[600] mr-[10px]"
                      style={{ display: railNav && "none" }}
                    >
                      <span className="relative left-[-0.5px]">
                        {Number(notificationCount) + Number(flooringCount)}
                      </span>
                    </span>
                  )}
                </AccordionSummary>
                <AccordionDetails
                  className={`sub_menu_box relative ${railNav && "hidden"}`}
                >
                  {authData?.permissions
                    ?.filter((it) => it?.name === "notification")
                    ?.map((it) =>
                      it?.submodules?.map(
                        (item) =>
                          item.permission == 1 && GetSideBarLink(item?.name, item)
                      )
                    )}
                </AccordionDetails>
              </Accordion>
            )}
          <div className="flex items-center dashboard_menu" onClick={Logout}>
            <AiOutlinePoweroff
              className={`text-[#0560FB] text-[17px] ${!railNav && "mr-[12px]"
                } ${railNav && "relative left-[1.7px]"}`}
            />
            <span className={`${railNav && "hidden"}`}>Logout</span>
          </div>
          <div className="flex-[1_1_auto] flex items-end pt-[30px] pb-[20px]">
            <div
              className={`flex items-center ${railNav ? "px-[13px]" : "px-[17px]"
                } text-[#0F172A] text-[13px]`}
            >
              <img
                // src={`${IMAGE_BASE_URL}/${authData.icon}`}
                src={authData?.icon
                  ? `${IMAGE_BASE_URL}/${authData.icon}`
                  : Noimage}
                alt="profile icon"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = Noimage; // ✅ Set fallback image on error
                }}
                className="mr-[12px] h-[20px] w-[20px] object-contain"
              />

              <span className={`${railNav && "hidden"} font-[500]`}>
                {authData?.name}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
